window.dataLayer = window.dataLayer || [];

function swymCallbackFn(swat) {
  // Swym event listeners
  // Product added to wishlist/favourites
  swat.evtLayer.addEventListener(
    swat.JSEvents.addedToWishlist,
    function (event) {
      console.log(event);

      sendAlgoliaEvent(event);
      sendGAEvent(event);
      sendDYEvent(event);

      setTimeout(function () {
        refreshFavouritesDropdown();
        document.dispatchEvent(new CustomEvent('swym:variant-changed'));
      }, 1000);
    }
  );

  // Product removed to wishlist/favourites
  swat.evtLayer.addEventListener(
    swat.JSEvents.removedFromWishlist,
    function (event) {
      sendAlgoliaEvent(event);
      sendGAEvent(event);
      sendDYEvent(event);

      console.log('swym:removedFromWishlist');
      console.log(event);

      setTimeout(function () {
        refreshFavouritesDropdown();
        document.dispatchEvent(new CustomEvent('swym:variant-changed'));
      }, 1000);
    }
  );

  // Initialize wishlist button when content is dynamically loaded on search/PLP
  document.addEventListener('swym:collections-loaded', function () {
    console.log('swym:collections-loaded');
    swat.initializeActionButtons('.listing-grid');
  });

  // Initialize wishlist button when there is a change in variant
  document.addEventListener('swym:variant-changed', function (event) {
    swat.initializeActionButtons('.wishlist__button');
  });

  refreshFavouritesDropdown();
}

function sendGAEvent(event) {
  const productTitle = event.detail.d.dt;
  const eventAction = event.type === 'sw:addedtowishlist' ? 'ADDED' : 'REMOVED';
  const page = window.location.pathname.startsWith('/products/')
    ? 'PDP'
    : 'PLP';

  window.dataLayer.push({
    event: `${page}-${eventAction}-WISHLIST`,
    action: `${page}-${eventAction}-WISHLIST`,
    category: 'wishlist',
    label: productTitle,
  });
}

function sendDYEvent(event) {
  const product = event.detail.d;
  const eventAction = event.type === 'sw:addedtowishlist' ? 'ADDED' : 'REMOVED';
  const page = window.location.pathname.startsWith('/products/')
    ? 'PDP'
    : 'PLP';

  const size = product.vi.split(' / ');

  DY.API('event', {
    name: `${page}-${eventAction}-WISHLIST`,
    properties: {
      product: {
        title: product.dt,
        price: product.pr,
        sku: product.sku,
        productId: product.empi,
        variant: product.epi,
        size: size[size.length - 1],
      },
    },
  });
}

function sendAlgoliaEvent(event) {
  const action =
    event.type === 'sw:addedtowishlist' ? 'Added to' : 'Removed from';
  const productId = String(event.detail.d.empi);
  const variantId = String(event.detail.d.epi);

  // PDP
  if (window.location.pathname.startsWith('/products/')) {
    // Check if the user reached this product from Algolia (via Search or PLP basically)
    const productData =
      JSON.parse(localStorage.getItem('algoliaProducts')) || [];
    const product = productData.find((p) => p.productId === productId);

    if (product) {
      aa('convertedObjectIDsAfterSearch', {
        userToken: getAlgoliaUserToken(),
        eventName: `PDP: ${action} Wishlist`,
        index: `${algoliaShopify.config.index_prefix}products`,
        objectIDs: [variantId],
        queryID: product.queryId,
      });
    } else {
      aa('convertedObjectIDs', {
        userToken: getAlgoliaUserToken(),
        eventName: `PDP: ${action} Wishlist`,
        index: `${algoliaShopify.config.index_prefix}products`,
        objectIDs: [variantId],
      });
    }
  } else {
    // PLP
    const listing = document.querySelector('algolia-listing');

    if (listing) {
      aa('convertedObjectIDsAfterSearch', {
        userToken: getAlgoliaUserToken(),
        eventName: `PLP: ${action} Wishlist`,
        index: listing.buildIndexParams(),
        objectIDs: [variantId],
        queryID: listing.queryId,
      });
    } else {
      aa('convertedObjectIDs', {
        userToken: getAlgoliaUserToken(),
        eventName: `PLP: ${action} Wishlist`,
        index: `${algoliaShopify.config.index_prefix}products`,
        objectIDs: [variantId],
      });
    }
  }
}

function refreshFavouritesDropdown() {
  document.querySelector('[data-quick-favourites-products]').innerHTML = '';

  window._swat.fetch(function (products) {
    //refreshFavouritesCount(products);
    if (products.length == 0) {
      document
        .querySelector('[data-quick-favourites]')
        .classList.remove('quick-favourites--enabled');
      return products;
    } else {
      document
        .querySelector('[data-quick-favourites]')
        .classList.add('quick-favourites--enabled');
    }

    buildFavouritesDropdown(products);
  });
}

function refreshFavouritesCount(products) {
  document
    .querySelectorAll('[data-header-favourites-count]')
    .forEach((node, index) => {
      node.innerHTML = `${products.length}`;

      if (products.length == 0) {
        node.style.display = 'none';
      } else {
        node.style.display = 'inline';
      }
    });
}

function sortByVariantTitle(a, b) {
  const sortScript = document.getElementById('fav_S_order');
  if (!sortScript) return 0;

  const cleanSortOrder = sortScript.innerText
    .replace(/\\n/g, '')
    .replace(/[\n\r;\[\]]/g, '')
    .replace(/\\\"/g, '"')
    .replace(/\"/g, '')
    .split(',')
    .map((item) => item.trim());

  if (cleanSortOrder.length === 0) return 0;

  return (
    cleanSortOrder.indexOf(a.option2.toLowerCase().trim()) -
    cleanSortOrder.indexOf(b.option2.toLowerCase().trim())
  );
}

async function buildFavouritesDropdown(products) {
  // TODO: Convert to section API
  return;

  for (const product of products) {
    let productUrlMatch = product.du.match(/\/products\/.+/);
    if (!productUrlMatch) continue;

    let productUrl = productUrlMatch[0] + '.js';

    try {
      let res = await fetch(productUrl);
      let p = await res.json();

      let variantInStock = false;
      let select = `<option> Select a size </option>`;

      // Sort variants before rendering dropdown
      let sortedVariants = p.variants.sort(sortByVariantTitle);

      sortedVariants.forEach((v) => {
        if (v.available) {
          variantInStock = true;
          let selected = '';
          if (v.compare_at_price && v.compare_at_price != v.price) {
            let price = document.querySelector(
              `.quick-favourites__product[data-product-id="${product.empi}"][data-variant-id="${product.epi}"] [data-original-price]`
            );
            if (price) {
              price.innerHTML = `<s>${(v.compare_at_price / 100).dollar()}</s>
                                  <span><span>Now</span> ${(
                                    v.price / 100
                                  ).dollar()}</span>`;
            }
          }
          select += `<option value="${
            v.id
          }" ${selected}>${v.option1.toUpperCase()} / ${v.option2.toUpperCase()}</option>`;
        }
      });

      if (!variantInStock) {
        let selectedVariant = p.variants.find((v) => v.id === product.epi);
        if (
          selectedVariant &&
          selectedVariant.compare_at_price &&
          selectedVariant.compare_at_price != selectedVariant.price
        ) {
          let price = document.querySelector(
            `.quick-favourites__product[data-product-id="${product.empi}"][data-variant-id="${product.epi}"] [data-original-price]`
          );
          if (price) {
            price.innerHTML = `<s>${(
              selectedVariant.compare_at_price / 100
            ).dollar()}</s>
                               <span><span>Now</span> ${(
                                 selectedVariant.price / 100
                               ).dollar()}</span>`;
          }
        }
      }

      // Append select to product options
      const productSelectEl = document.querySelector(
        '.favourite-product-card__variants[data-selected-product="' +
          product.empi +
          '"]'
      );
      if (productSelectEl) {
        productSelectEl.innerHTML = select;
      }
    } catch (err) {
      console.error('Unable to fetch product', err);
    }

    let string = `
      <div class="quick-favourites__product" data-variant-id="${product.epi}" data-product-id="${product.empi}">
        <div class="quick-favourites__product-image">
          <a class="naked-link" href="${product.du}">
            <img src="${product.iu}" alt="${product.dt}" />
          </a>
        </div>
        <div class="quick-favourites__product-details">
          <a class="hover-link quick-favourites__product-link" href="${product.du}">${product.dt}</a>
          <span class="quick-favourites__product-price product-price" data-original-price="${product.empi}">$${product.pr}</span>
          <div class="quick-favourites__product-options">
          </div>
        </div>
      </div>`;

    document
      .querySelector('[data-quick-favourites-products]')
      .append(string.createContext());
  }
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);
